module.exports = __webpack_public_path__ + "assets/img/FormTeam.b8449092.png";